import InternalLink from './InternalLinks';

export default InternalLink;
